import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

import wizardsShape from 'core/components/wizard/shapes'
import Wizard from 'core/components/wizard'

import { aStepsTradeInConfig1, aStepsTradeInConfig2 } from './steps'

const mapStateToProps = state => ({
  idReferential: state.configuration.campaign.idReferential
})

const TradeIn = props => {
  const [steps, setSteps] = useState(null)

  const { setWizards, wizards, tradeInConfig, /* resetTradeInWizard,*/ idReferential } = props

  const aStepsActive = wizards.aStepsTradeIn
  let newWizards = {}

  useEffect(() => {
    switch (tradeInConfig) {
      case 2:
        setSteps(aStepsTradeInConfig2(String(idReferential)))
        newWizards = {
          ...wizards,
          aStepsTradeIn: aStepsTradeInConfig2(String(idReferential)).map(x => x.data)
        }
        break
      case 1:
      default:
        setSteps(aStepsTradeInConfig1(String(idReferential)))
        newWizards = {
          ...wizards,
          aStepsTradeIn: aStepsTradeInConfig1(String(idReferential)).map(x => x.data)
        }
        break
    }

    const extendedWizard = {
      ...newWizards,
      activeWizard: 'aStepsTradeIn'
    }
    setWizards(extendedWizard)

    // resetTradeInWizard(tradeInConfig)
  }, [])

  return (
    steps && <Wizard aSteps={steps} aStepsActive={aStepsActive} data-test="component-tradeIn" />
  )
}

TradeIn.propTypes = {
  setWizards: PropTypes.func.isRequired,
  resetTradeInWizard: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  tradeInConfig: PropTypes.number.isRequired
}

/* eslint-disable-next-line react-redux/prefer-separate-component-file */
const withConnect = connect(mapStateToProps)(TradeIn)
export default injectIntl(withConnect)
